export const ExperimentNames = {
    // Forever experiment
    UseWarmupState: 'specs.events.ui.UseWarmupState',
    EventDetailsSlots: 'specs.events.ui.EventDetailsSlots',
    EventDetailsSlotsViewer: 'specs.events.ui.EventDetailsSlotsViewer',
    DashboardSlots: 'specs.events.ui.DashboardSlots',
    ExpressCheckout: 'specs.events.ui.ExpressCheckout',
    RsvpDynamicMessages: 'specs.events.ui.RsvpDynamicMessages',
    RicosBusinessManager: 'specs.events.ui.Ricos',
    RicosViewer: 'specs.events.ui.RicosViewer',
    GetRichContentByEventId: 'specs.events.ui.GetRichContentByEventId',
    SausageIntegration: 'specs.events.ui.SausageIntegration',
    RemoveLiveVideoAccess: 'specs.events.ui.RemoveLiveVideoAccess',
    UpdatePaymentTermsPaypal: 'specs.events.ui.UpdatePaymentTermsPaypal',
    UpdatePaymentTermsSquare: 'specs.events.ui.UpdatePaymentTermsSquare',
    SettingsPanelUpdatedTranslations: 'specs.events.ui.SettingsPanelUpdatedTranslations', // false 100%, 2024,07-12
    DisableEventCreationForPaypal: 'specs.events.ui.DisableEventCreationForPaypal',
    DescriptionVisibility: 'specs.events.ui.DescriptionVisibility', // false 100%, 2024-07-12
    AddMultipleGuestsManually: 'specs.events.ui.AddMultipleGuestsManually',
    SingleEventNoRegistrationTextSetting: 'specs.events.ui.SingleEventNoRegistrationTextSetting', // English 100%, 2024-07-12
    BMContentUpdates: 'specs.events.ui.BMContentUpdates', // English 100%, 2024-07-12
    TicketMoreInfoButtonSetting: 'specs.events.ui.TicketMoreInfoButtonSetting',
    AiAssistant: 'specs.events.ui.AiAssistant',
    AiTicketsAssistant: 'specs.events.ui.AiTicketsAssistant',
    NewPolicyFontColor: 'specs.events.ui.NewPolicyFontColor',
    ServiceFeeEnforcementUpdates: 'specs.events.ui.ServiceFeeEnforcementUpdates',
    UpdatedCheckoutSummary: 'specs.events.ui.UpdatedCheckoutSummary',
    CategoriesUXImprovements: 'specs.events.ui.CategoriesUXImprovements',
    GuestListDefaultSort: 'specs.events.ui.GuestListDefaultSort',
    UpdatePaymentMethodEnabled: 'specs.events.ui.UpdatePaymentMethodEnabled',
    AutomationV3Enabled: 'automations.SiteOnV3AutomationsBuilder',
    OfferExpressCheckout: 'specs.events.ui.OfferExpressCheckout',
    WidgetSEOTags: 'specs.events.ui.WidgetSEOTags',
    AddMultipleGuestsManuallyRSVP: 'specs.events.ui.AddMultipleGuestsManuallyRSVP',
    UpdateTicketResendFlow: 'specs.events.ui.UpdateResendTicketFlow',
    MemberOnlyEventError: 'specs.events.ui.MemberOnlyEventError',
    UpdateOrderSuccessContent: 'specs.events.ui.UpdateOrderSuccessContent',
    TicketDefinitionsV3Migration: 'specs.events.ui.TicketDefinitionsV3Migration',
    DisableMobileFontOverrides: 'specs.events.ui.DisableMobileFontOverrides',
    UnauthorizedErrorPage: 'specs.events.ui.UnauthorizedErrorPage',
    UpdateServiceFeeConfigDesign: 'specs.events.ui.UpdateServiceFeeConfigDesign',
    UpdateGuestEmail: 'specs.events.ui.UpdateGuestEmail',
    UpdateTicketListEmptyState: 'specs.events.ui.UpdateTicketListEmptyState',
    GroupConnectedToEventPrivacy: 'specs.groups.GroupConnectedToEventPrivacy',
    UseGuestsService: 'specs.events.ui.UseGuestsService',
    WixLiveTerminationWarnings: 'specs.events.ui.WixLiveTerminationWarnings',
    FixPaidPlans: 'specs.events.ui.FixPaidPlans',
    UpdateDisplayEventsLabel: 'specs.events.ui.UpdateDisplayEventsLabel',
    DisableMembershipEntryForDraftEvents: 'specs.events.ui.DisableMembershipEntryForDraftEvents',
    DonationKeyboardMode: 'specs.events.ui.DonationKeyboardMode',
};
//# sourceMappingURL=experiments.js.map